import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
    selector: "app-upload-cv-button",
    standalone: true,
    imports: [CommonModule],
    templateUrl: "./upload-cv-button.html",
})
export class UploadCvButtonComponent {}